/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { GoogleConsentCookieBanner } from '@uncinc/uncinc-react-kitchen-sink';
import { AvailableConsentPermissions } from '@uncinc/uncinc-react-kitchen-sink/dist/components/GoogleConsentCookieBanner/types';
import config from 'react-global-configuration';
import {
  APP_OPTIONS, BURENDAG_DOMAIN, NLDOET_DOMAIN,
} from '../../config/constants';

import './style.scss';

const Cookie = () => {
  const { t } = useTranslation();
  const currentDomain = config.get('CURRENT_DOMAIN') as typeof BURENDAG_DOMAIN | typeof NLDOET_DOMAIN;
  const titleMap = {
    [BURENDAG_DOMAIN]: t('cookies.burendagTitle'),
    [NLDOET_DOMAIN]: t('cookies.nldoetTitle'),
  };

  const title = titleMap[currentDomain] || t('cookies.title');

  return (
    <GoogleConsentCookieBanner
      title={title || t('cookies.title')}
      necessaryButtonInverted={false}
      showAcceptOnlyNeededSelections
      cookieLevels={[
        {
          value: 'necessary',
          label: t('cookies.categories.necessary.label'),
          description: t('cookies.categories.necessary.description'),
          disabled: true,
          consentOptions: [
            AvailableConsentPermissions.SECURITY_STORAGE,
          ],
        },
        {
          value: 'marketing',
          label: t('cookies.categories.marketing.label'),
          // @ts-ignore
          description: (
            <Trans
              i18nKey="cookies.categories.marketing.description"
              components={{
                cookie: <a href={APP_OPTIONS.parameters.cookieSettingsPath} />,
                partners: <a href={APP_OPTIONS.parameters.cookiePatnersPath} />,
              }}
            />
          ),
          disabled: false,
          consentOptions: [
            AvailableConsentPermissions.FUNCTIONALITY_STORAGE,
            AvailableConsentPermissions.PERSONALISATION_STORAGE,
            AvailableConsentPermissions.ANALYTICS_STORAGE,
            AvailableConsentPermissions.AD_PERSONALISATION,
            AvailableConsentPermissions.AD_USER_DATA,
            AvailableConsentPermissions.AD_STORAGE,
          ],
        },
      ]}
    >
      <p className="body--small">
        <Trans
          i18nKey="cookies.intro"
          components={{
            cookie: <a href={APP_OPTIONS.parameters.cookieSettingsPath} />,
            partners: <a href={APP_OPTIONS.parameters.cookiePatnersPath} />,
          }}
        />
      </p>
    </GoogleConsentCookieBanner>
  );
};
export default Cookie;
